/**
 * Culture Drops – Schnellwahl "Alle Shirts in einer Größe"
 * ========================================================
 * Ersetzt das alte Fast-Bundle-Sync-Skript. Fast Bundle ist nicht mehr im Einsatz;
 * die Sets laufen über die native Shopify-Bundles-App mit einem Größen-Dropdown je Shirt.
 *
 * Was das Skript macht:
 *   Auf Produktseiten, die MEHRERE Optionen mit exakt denselben Auswahlwerten haben
 *   (bei den Sets: "Größe BOYS" und "Größe DON'T CRY", beide S/M/L/XL/2XL), wird über
 *   der Auswahl eine Button-Reihe eingefügt. Ein Klick setzt alle gleichzeitig.
 *   Die individuelle Auswahl pro Shirt bleibt möglich.
 *
 * Sprachunabhängig: Es wird NICHT auf den Optionsnamen ("Größe" / "Size") geprüft,
 * sondern darauf, dass zwei oder mehr Optionen dieselben Werte anbieten. Damit
 * funktioniert es in jeder Sprache des Shops und übersteht Umbenennungen.
 *
 * Hinweis zum Dateinamen: heißt weiterhin fast-bundle-size-sync.js, weil sie in
 * layout/theme.liquid bereits eingebunden ist. Inhaltlich nichts mit Fast Bundle zu tun.
 */
 
(function () {
  'use strict';
 
  var BOX_CLASS = 'cd-quickpick';
  var observer = null;
 
  var TEXT = {
    de: { label: 'Alle Shirts in einer Größe',
          hint:  'Oder unten für jedes Shirt eine eigene Größe wählen.' },
    en: { label: 'All shirts in one size',
          hint:  'Or pick a different size for each shirt below.' }
  };
 
  function strings() {
    var lang = (document.documentElement.getAttribute('lang') || 'en').toLowerCase();
    return lang.indexOf('de') === 0 ? TEXT.de : TEXT.en;
  }
 
  var CSS = [
    '.cd-quickpick{margin:0 0 1.6rem;padding:1.2rem 1.4rem;border:.1rem solid rgba(var(--color-foreground),.18);border-radius:.8rem}',
    '.cd-quickpick__label{display:block;margin-bottom:.9rem;font-size:1.4rem;font-weight:600;letter-spacing:.04rem}',
    '.cd-quickpick__row{display:flex;flex-wrap:wrap;gap:.6rem}',
    '.cd-quickpick__btn{cursor:pointer;min-width:4.4rem;padding:.8rem 1.4rem;border:.1rem solid rgba(var(--color-foreground),.4);border-radius:2.6rem;background:transparent;color:rgb(var(--color-foreground));font-family:inherit;font-size:1.4rem;line-height:1;transition:background .15s,color .15s,border-color .15s}',
    '.cd-quickpick__btn:hover{border-color:rgb(var(--color-foreground))}',
    '.cd-quickpick__btn[aria-pressed="true"]{background:rgb(var(--color-foreground));color:rgb(var(--color-background));border-color:rgb(var(--color-foreground))}',
    '.cd-quickpick__hint{display:block;margin-top:.9rem;font-size:1.2rem;opacity:.65}'
  ].join('');
 
  function injectCss() {
    if (document.getElementById('cd-quickpick-css')) return;
    var style = document.createElement('style');
    style.id = 'cd-quickpick-css';
    style.textContent = CSS;
    document.head.appendChild(style);
  }
 
  function pickerRoot() {
    return document.querySelector('variant-selects, variant-radios');
  }
 
  function allFieldsets() {
    var root = pickerRoot();
    if (!root) return [];
    return Array.prototype.filter.call(
      root.querySelectorAll('.product-form__input'),
      function (fs) {
        return !!(fs.querySelector('input[type=radio]') || fs.querySelector('select'));
      }
    );
  }
 
  function valuesOf(fs) {
    var sel = fs.querySelector('select');
    if (sel) {
      return Array.prototype.map.call(sel.options, function (o) { return o.value; });
    }
    return Array.prototype.map.call(
      fs.querySelectorAll('input[type=radio]'),
      function (i) { return i.value; }
    );
  }
 
  function currentOf(fs) {
    var sel = fs.querySelector('select');
    if (sel) return sel.value;
    var checked = fs.querySelector('input[type=radio]:checked');
    return checked ? checked.value : null;
  }
 
  /* Findet die groesste Gruppe von Optionen, die exakt dieselben Werte anbieten.
     Genau das sind bei einem Set die Groessen-Dropdowns der einzelnen Shirts. */
  function matchingGroup() {
    var groups = {};
    allFieldsets().forEach(function (fs) {
      var values = valuesOf(fs);
      if (values.length < 2) return;
      var key = values.slice().sort().join(' ');
      (groups[key] = groups[key] || []).push(fs);
    });
    var best = null;
    Object.keys(groups).forEach(function (key) {
      if (groups[key].length < 2) return;
      if (!best || groups[key].length > best.length) best = groups[key];
    });
    return best;
  }
 
  /* Setzt in jedem Feld der Gruppe denselben Wert und feuert danach EIN change-Event,
     damit Dawn die passende Variante genau einmal nachlaedt. */
  function applyToAll(value) {
    var group = matchingGroup();
    if (!group) return;
    var last = null;
    group.forEach(function (fs) {
      var sel = fs.querySelector('select');
      if (sel) {
        var exists = Array.prototype.some.call(sel.options, function (o) { return o.value === value; });
        if (exists) { sel.value = value; last = sel; }
        return;
      }
      Array.prototype.forEach.call(fs.querySelectorAll('input[type=radio]'), function (input) {
        if (input.value === value) { input.checked = true; last = input; }
      });
    });
    if (last) last.dispatchEvent(new Event('change', { bubbles: true }));
  }
 
  /* Bewusst setTimeout statt requestAnimationFrame: rAF pausiert in Hintergrund-Tabs,
     dann bliebe die Hervorhebung stehen. Mehrere Zeitpunkte, weil Dawn den
     Varianten-Picker asynchron nachlaedt. */
  function syncSoon() {
    [0, 120, 400, 900].forEach(function (delay) {
      setTimeout(syncPressedState, delay);
    });
  }
 
  function syncPressedState() {
    var box = document.querySelector('.' + BOX_CLASS);
    if (!box) return;
    var group = matchingGroup();
    if (!group) return;
    var values = group.map(currentOf);
    var allSame = values.length > 0 && values.every(function (v) { return v && v === values[0]; });
    Array.prototype.forEach.call(box.querySelectorAll('.cd-quickpick__btn'), function (btn) {
      btn.setAttribute('aria-pressed', String(allSame && btn.getAttribute('data-value') === values[0]));
    });
  }
 
  function buildBox(values) {
    var t = strings();
    var box = document.createElement('div');
    box.className = BOX_CLASS;
 
    var label = document.createElement('span');
    label.className = 'cd-quickpick__label';
    label.textContent = t.label;
    box.appendChild(label);
 
    var row = document.createElement('div');
    row.className = 'cd-quickpick__row';
    values.forEach(function (value) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cd-quickpick__btn';
      btn.setAttribute('data-value', value);
      btn.setAttribute('aria-pressed', 'false');
      btn.textContent = value;
      row.appendChild(btn);
    });
    box.appendChild(row);
 
    var hint = document.createElement('span');
    hint.className = 'cd-quickpick__hint';
    hint.textContent = t.hint;
    box.appendChild(hint);
 
    return box;
  }
 
  function ensure() {
    var existing = document.querySelector('.' + BOX_CLASS);
    var root = pickerRoot();
 
    if (!root) { if (existing) existing.remove(); return; }
 
    var group = matchingGroup();
    if (!group) { if (existing) existing.remove(); return; }
 
    if (!existing) {
      injectCss();
      root.parentNode.insertBefore(buildBox(valuesOf(group[0])), root);
    }
    syncPressedState();
    watch(root.parentNode);
  }
 
  /* Dawn ersetzt den Varianten-Picker nach jeder Auswahl komplett.
     Der Observer setzt die Schnellwahl danach wieder ein.
     Nur childList, keine Attribute - sonst wuerde syncPressedState() sich selbst triggern. */
  function watch(target) {
    if (!target || observer) return;
    observer = new MutationObserver(function () {
      setTimeout(ensure, 0);
    });
    observer.observe(target, { childList: true, subtree: true });
  }
 
  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('.cd-quickpick__btn') : null;
    if (!btn) return;
    event.preventDefault();
    applyToAll(btn.getAttribute('data-value'));
    syncSoon();
  });
 
  document.addEventListener('change', function () {
    syncSoon();
  });
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensure);
  } else {
    ensure();
  }
 
  document.addEventListener('shopify:section:load', function () {
    if (observer) { observer.disconnect(); observer = null; }
    ensure();
  });
})();
 